import { FunctionsFetchError, FunctionsHttpError, FunctionsRelayError } from '@supabase/supabase-js'

function payloadMessage(payload: unknown) {
  if (!payload || typeof payload !== 'object') return null
  const value = 'error' in payload ? payload.error : 'message' in payload ? payload.message : null
  return typeof value === 'string' && value.trim() ? value.trim() : null
}

export async function functionErrorMessage(error: unknown, fallback: string) {
  if (error instanceof FunctionsHttpError) {
    try {
      const message = payloadMessage(await error.context.json())
      if (message) return message
    } catch { /* The status-specific fallback below still applies. */ }
    if (error.context.status === 429) return 'Attendi qualche secondo prima di commentare di nuovo.'
  }

  if (error instanceof FunctionsFetchError || error instanceof FunctionsRelayError) {
    return 'Il servizio commenti non è momentaneamente raggiungibile. Riprova tra poco.'
  }

  return fallback
}
